export const conversationEndToken = "[CONVERSATION_END]";
export const conversationEndNegativeToken = "[CONVERSATION_END_NEGATIVE]";
export const minNumberOfMessages = 2;
